import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthSelectorsFacade } from '../state/auth.selectors.facade';

export const guestGuard: CanActivateFn = () => {
  const isAuthenticated = inject(AuthSelectorsFacade).isAuthenticated;

  if (isAuthenticated()) {
    return inject(Router).createUrlTree(['/dashboard']);
  }

  return true;
};
